import { render } from "./NBURates.vue?vue&type=template&id=2f9e8646&scoped=true&ts=true"
import script from "./NBURates.vue?vue&type=script&lang=ts"
export * from "./NBURates.vue?vue&type=script&lang=ts"

import "./NBURates.vue?vue&type=style&index=0&id=2f9e8646&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9e8646"]])

export default __exports__